import listActions from 'src/modules/packagingCertification/list/packagingCertificationListActions';
import PackagingCertificationService from 'src/modules/packagingCertification/packagingCertificationService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import Message from 'src/view/shared/message';
import { navigateTo } from 'src/view/shared/routes/helpers';

const prefix = 'PACKAGINGCERTIFICATION_DESTROY';

const packagingCertificationDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: packagingCertificationDestroyActions.DESTROY_STARTED,
      });

      await PackagingCertificationService.destroyAll([id]);

      dispatch({
        type: packagingCertificationDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(i18n('entities.packagingCertification.destroy.success'));

      dispatch(listActions.doFetchCurrentFilter());

      navigateTo('/library/packaging-certification');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: packagingCertificationDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: packagingCertificationDestroyActions.DESTROY_ALL_STARTED,
      });

      await PackagingCertificationService.destroyAll(ids);

      dispatch({
        type: packagingCertificationDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doChangeSelected([]));
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.packagingCertification.destroyAll.success'),
      );

      navigateTo('/library/packaging-certification');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: packagingCertificationDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default packagingCertificationDestroyActions;
